import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { isObject, isUndefined } from 'lodash-es';
import classNames from 'classnames';
import { breakpointInfix, Enum } from '../../library';
export var FlexJustifyType = Enum({
  START: 'start',
  END: 'end',
  CENTER: 'center',
  BETWEEN: 'between',
  AROUND: 'around',
  EVEN: 'even'
});
export var FlexAlignType = Enum({
  START: 'start',
  END: 'end',
  CENTER: 'center',
  BASELINE: 'baseline',
  STRETCH: 'stretch'
});
export var flexClasses = {
  direction: {
    row: 'flex--row',
    rowReverse: 'flex--row-reverse',
    column: 'flex--column',
    columnReverse: 'flex--column-reverse'
  },
  wrap: {
    wrap: 'flex--wrap',
    none: 'flex--nowrap',
    reverse: 'flex--wrap-reverse'
  },
  alignItems: {
    start: 'align-items--start',
    end: 'align-items--end',
    center: 'align-items--center',
    baseline: 'align-items--baseline',
    stretch: 'align-items--stretch'
  },
  alignContent: {
    start: 'align-content--start',
    end: 'align-content--end',
    center: 'align-content--center',
    between: 'align-content--between',
    around: 'align-content--around',
    stretch: 'align-content--stretch'
  },
  justify: {
    start: 'justify--start',
    end: 'justify--end',
    center: 'justify--center',
    between: 'justify--between',
    around: 'justify--around',
    even: 'justify--even'
  }
};
export function getFlexAlignClass(align) {
  if (isUndefined(align)) return '';
  var respObj = isObject(align) ? align : {
    xs: align
  };
  var classes = Object.keys(respObj).reduce(function (acc, bp) {
    var val = respObj[bp];
    if (isUndefined(val)) return acc;
    return [].concat(_toConsumableArray(acc), ["".concat(flexClasses.alignItems[val]).concat(breakpointInfix(bp))]);
  }, []);
  return classNames(classes);
}
export function getFlexJustifyClass(justify) {
  if (isUndefined(justify)) return '';
  var respObj = isObject(justify) ? justify : {
    xs: justify
  };
  var classes = Object.keys(respObj).reduce(function (acc, bp) {
    var val = respObj[bp];
    if (isUndefined(val)) return acc;
    return [].concat(_toConsumableArray(acc), ["".concat(flexClasses.justify[val]).concat(breakpointInfix(bp))]);
  }, []);
  return classNames(classes);
}